/* Sign-in sheet (window.BSLogin): "Continue with Google" or "Continue with WhatsApp".
   Google (or an email code) is Shopify's own sign-in page; Google is connected
   there in Settings -> Customer accounts, and data-google says it is. WhatsApp is
   a 6-digit code, then a 30-day BagSafe session kept in this browser. A Shopify
   session still wins in the header, and My bookings shows bookings from both.
   Loaded on every page by the header; the sheet and its CSS are built only
   when someone opens it. */
(function () {
  if (window.BSLogin) return;
  var me = document.currentScript;
  var API = (me && me.getAttribute('data-api')) || '';
  var CSS = (me && me.getAttribute('data-css')) || '';
  var EMAIL_URL = (me && me.getAttribute('data-email-login')) || '/account/login';
  var BOOKINGS = (me && me.getAttribute('data-bookings')) || '/pages/my-bookings';
  var SHOPIFY_CUSTOMER = me && me.getAttribute('data-customer') === 'true';
  // Only promise Google once it is connected in Shopify (theme setting bs_google_login).
  var GOOGLE = me && me.getAttribute('data-google') === 'true';
  var KEY = 'bagsafe.session', PKEY = 'bagsafe.profile';

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function session() { var s = get(KEY); return s && /^bss_/.test(s) ? s : null; }
  function profile() { try { return JSON.parse(get(PKEY) || 'null'); } catch (e) { return null; } }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function api(path, body) {
    var url = API.replace(/\/+$/, '') + path;
    if (/\.supabase\.co\//.test(url)) url += '?forceFunctionRegion=ap-northeast-1';
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok) { var e = new Error(j.message || 'Something went wrong. Please try again.'); e.code = j.error; throw e; }
          return j;
        });
      });
  }

  /* ---------------------------------------------------------------- header */
  function initialsOf(name) {
    return String(name || '').trim().split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0).toUpperCase(); }).join('') || '•';
  }
  function paintHeader() {
    if (SHOPIFY_CUSTOMER) return;
    var p = profile(), on = !!session();
    document.querySelectorAll('[data-bsh-acct]').forEach(function (a) {
      if (!a.hasAttribute('data-bs-orig')) a.setAttribute('data-bs-orig', a.innerHTML + '|' + a.getAttribute('href'));
      if (on) {
        a.setAttribute('href', BOOKINGS);
        a.removeAttribute('data-bs-login-open');
        a.setAttribute('aria-label', 'My bookings, signed in' + (p && p.first_name ? ' as ' + p.first_name : ''));
        a.innerHTML = '<span class="bsh__acct-av" aria-hidden="true">' + esc(initialsOf(p && p.name)) + '</span><span class="bsh__acct-label">My bookings</span>';
      } else {
        var orig = a.getAttribute('data-bs-orig').split('|');
        a.innerHTML = orig.slice(0, -1).join('|');
        a.setAttribute('href', orig[orig.length - 1]);
        a.setAttribute('data-bs-login-open', '');
        a.removeAttribute('aria-label');
      }
    });
    document.querySelectorAll('[data-bs-when]').forEach(function (el) {
      el.hidden = el.getAttribute('data-bs-when') === 'in' ? !on : on;
    });
  }

  /* ---------------------------------------------------------------- mobile on/off */
  // The backend says whether a sign-in code can reach a phone (/login/status). Until
  // it can, login links keep their Shopify email-code href and the page keeps its
  // email copy; the answer is cached for this tab for 10 minutes.
  var MKEY = 'bagsafe.mobile', mobile = null, waiting = [];

  function cachedMobile() {
    try {
      var c = JSON.parse(sessionStorage.getItem(MKEY) || 'null');
      return c && Date.now() - c.at < 600000 ? !!c.on : null;
    } catch (e) { return null; }
  }
  function settleMobile(on) {
    mobile = on;
    try { sessionStorage.setItem(MKEY, JSON.stringify({ on: on, at: Date.now() })); } catch (e) {}
    paintMobile();
    var w = waiting; waiting = [];
    w.forEach(function (cb) { cb(on); });
  }
  function mobileState(cb) {
    if (mobile !== null) { cb(mobile); return; }
    waiting.push(cb);
    if (waiting.length > 1) return;
    var c = cachedMobile();
    if (c !== null) { settleMobile(c); return; }
    // No answer means no code either way, so fall back to email.
    api('/login/status').then(function (j) { settleMobile(j.mobile === true); }, function () { settleMobile(false); });
  }
  function paintMobile() {
    var on = mobile === true;
    document.querySelectorAll('[data-bs-mobile-only]').forEach(function (el) { el.hidden = !on; });
    document.querySelectorAll('[data-bs-email-only]').forEach(function (el) { el.hidden = on; });
    document.querySelectorAll('[data-bs-email-label]').forEach(function (el) {
      el.textContent = el.getAttribute(on ? 'data-bs-mobile-label' : 'data-bs-email-label');
    });
  }

  /* ---------------------------------------------------------------- sheet */
  var dlg, opts = {}, phone = '', resendAt = 0, tick = 0, busy = false;

  var ICON_GOOGLE = '<svg class="bsl__ico" viewBox="0 0 48 48" aria-hidden="true">' +
    '<path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>' +
    '<path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>' +
    '<path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z"/>' +
    '<path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>';
  var ICON_EMAIL = '<svg class="bsl__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>';
  var ICON_WA = '<svg class="bsl__ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#25D366"/>' +
    '<path fill="none" stroke="#fff" stroke-width="1.6" stroke-linejoin="round" d="M12 5.6a6.4 6.4 0 0 0-5.5 9.7l-.8 3 3.1-.8A6.4 6.4 0 1 0 12 5.6z"/>' +
    '<path fill="#fff" d="M9.6 9c.2-.4.4-.4.6-.4h.4c.1 0 .3 0 .4.3l.6 1.4c0 .1 0 .3-.1.4l-.4.5c-.1.1-.1.3 0 .4.6 1 1.4 1.7 2.4 2.2.1.1.3.1.4 0l.5-.6c.1-.1.3-.2.4-.1l1.4.7c.2.1.2.2.2.3 0 .4-.2 1-.7 1.3-.5.3-1.2.4-2.6-.2a7.9 7.9 0 0 1-3.6-3.3c-.6-1-.6-1.9-.3-2.9z"/></svg>';

  function loadCss() {
    if (!CSS || document.querySelector('link[data-bs-login-css]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CSS; l.setAttribute('data-bs-login-css', '');
    document.head.appendChild(l);
  }

  function build() {
    loadCss();
    dlg = document.createElement('dialog');
    dlg.className = 'bsl';
    dlg.setAttribute('aria-labelledby', 'bsl-title');
    dlg.innerHTML =
      '<div class="bsl__card">' +
        '<button type="button" class="bsl__x" data-bsl-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<p class="bsl__eyebrow" data-bsl-reason>Sign in</p>' +
        '<h2 class="bsl__title" id="bsl-title" data-bsl-title>Continue with your mobile</h2>' +
        '<p class="bsl__lede" data-bsl-lede>We’ll send a 6-digit code on WhatsApp. No password, and new customers are signed up automatically.</p>' +
        '<div class="bsl__choices" data-bsl-step="choose" hidden>' +
          '<a class="bsl__choice" href="' + esc(EMAIL_URL) + '" rel="nofollow" data-bsl-shopify>' + (GOOGLE ? ICON_GOOGLE : ICON_EMAIL) +
            '<span><strong>' + (GOOGLE ? 'Continue with Google' : 'Continue with email') + '</strong>' +
            '<small>' + (GOOGLE ? 'Your Google account, or a code by email' : 'We email you a 6-digit code') + '</small></span></a>' +
          '<button type="button" class="bsl__choice" data-bsl-whatsapp>' + ICON_WA +
            '<span><strong>Continue with WhatsApp</strong><small>We send a 6-digit code to your number</small></span></button>' +
        '</div>' +
        '<form class="bsl__form" data-bsl-step="phone" novalidate>' +
          '<label class="bsl__label" for="bsl-phone">Mobile number</label>' +
          '<div class="bsl__phone"><span aria-hidden="true">+91</span>' +
            '<input id="bsl-phone" name="tel" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="14" placeholder="98300 12345" required></div>' +
          '<button type="submit" class="bsl__btn">Send code on WhatsApp</button>' +
        '</form>' +
        '<form class="bsl__form" data-bsl-step="code" hidden novalidate>' +
          '<label class="bsl__label" for="bsl-code">6-digit code</label>' +
          '<input class="bsl__code" id="bsl-code" name="code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="••••••" required>' +
          '<button type="submit" class="bsl__btn">Verify and sign in</button>' +
          '<div class="bsl__row"><button type="button" class="bsl__textbtn" data-bsl-change>Change number</button>' +
          '<button type="button" class="bsl__textbtn" data-bsl-resend disabled>Resend code</button></div>' +
        '</form>' +
        '<p class="bsl__msg" data-bsl-msg role="alert" hidden></p>' +
        '<p class="bsl__alt" data-bsl-alt>' + (GOOGLE ? 'Prefer Google or email? <a href="' + esc(EMAIL_URL) + '" rel="nofollow" data-bsl-shopify>Sign in another way</a>'
          : 'Prefer email? <a href="' + esc(EMAIL_URL) + '" rel="nofollow" data-bsl-shopify>Use an email code instead</a>') + '</p>' +
        '<p class="bsl__fine">By continuing you agree to get booking updates from BagSafe. We never share your details.</p>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-bsl-close]')) close();
      else if (e.target.closest('[data-bsl-change]')) step('phone');
      else if (e.target.closest('[data-bsl-whatsapp]')) step('phone');
      else if (e.target.closest('[data-bsl-resend]')) send(true);
    });
    dlg.addEventListener('close', function () { clearInterval(tick); });
    q('[data-bsl-step="phone"]').addEventListener('submit', function (e) { e.preventDefault(); send(false); });
    q('[data-bsl-step="code"]').addEventListener('submit', function (e) { e.preventDefault(); verify(); });
    var code = q('#bsl-code');
    code.addEventListener('input', function () {
      code.value = code.value.replace(/\D/g, '').slice(0, 6);
      msg('');
      if (code.value.length === 6) verify();
    });
    var tel = q('#bsl-phone');
    tel.addEventListener('input', function () { msg(''); tel.removeAttribute('aria-invalid'); });
  }
  function q(sel) { return dlg.querySelector(sel); }
  function msg(text, tone) {
    var m = q('[data-bsl-msg]');
    m.textContent = text || '';
    m.hidden = !text;
    m.setAttribute('data-tone', tone || 'error');
  }
  function step(name) {
    q('[data-bsl-step="choose"]').hidden = name !== 'choose';
    q('[data-bsl-step="phone"]').hidden = name !== 'phone';
    q('[data-bsl-step="code"]').hidden = name !== 'code';
    // The chooser already offers Google / email as a button.
    q('[data-bsl-alt]').hidden = name === 'choose';
    msg('');
    if (name === 'choose') {
      q('[data-bsl-title]').textContent = 'Sign in or create an account';
      q('[data-bsl-lede]').textContent = 'Choose what suits you. No password, and new customers are signed up automatically.';
      setTimeout(function () { q('.bsl__choice').focus(); }, 30);
    } else if (name === 'phone') {
      q('[data-bsl-title]').textContent = 'Continue with your mobile';
      q('[data-bsl-lede]').textContent = 'We’ll send a 6-digit code on WhatsApp. No password, and new customers are signed up automatically.';
      setTimeout(function () { q('#bsl-phone').focus(); }, 30);
    } else {
      q('[data-bsl-title]').textContent = 'Enter your code';
      q('[data-bsl-lede]').innerHTML = 'Sent on WhatsApp to <strong>+91 ' + esc(phone.slice(0, 5) + ' ' + phone.slice(5)) + '</strong>. It expires in 10 minutes.';
      q('#bsl-code').value = '';
      setTimeout(function () { q('#bsl-code').focus(); }, 30);
    }
  }
  function setBusy(form, on, label) {
    busy = on;
    var b = form.querySelector('.bsl__btn');
    if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.textContent);
    b.disabled = on;
    b.setAttribute('aria-busy', on ? 'true' : 'false');
    b.textContent = on ? label : b.getAttribute('data-label');
  }
  function countdown() {
    var r = q('[data-bsl-resend]');
    clearInterval(tick);
    function draw() {
      var left = Math.ceil((resendAt - Date.now()) / 1000);
      r.disabled = left > 0;
      r.textContent = left > 0 ? 'Resend in ' + left + 's' : 'Resend code';
      if (left <= 0) clearInterval(tick);
    }
    draw();
    tick = setInterval(draw, 1000);
  }

  function send(resend) {
    if (busy) return;
    var tel = q('#bsl-phone');
    var d = tel.value.replace(/\D/g, '').replace(/^(?:91|0)(?=\d{10}$)/, '');
    if (!/^[6-9]\d{9}$/.test(d)) {
      tel.setAttribute('aria-invalid', 'true');
      msg('Enter a 10-digit Indian mobile number.');
      tel.focus();
      return;
    }
    phone = d;
    var form = q(resend ? '[data-bsl-step="code"]' : '[data-bsl-step="phone"]');
    setBusy(form, true, resend ? 'Sending…' : 'Sending code…');
    api('/login/start', { phone: d })
      .then(function (res) {
        setBusy(form, false);
        resendAt = Date.now() + (res.resend_in || 30) * 1000;
        if (!resend) step('code');
        countdown();
        if (res.channel === 'test') msg('Test mode: no WhatsApp was sent. Ask the BagSafe team for your code.', 'info');
        else if (resend) msg('New code sent.', 'info');
        if (res.channel === 'whatsapp') watchDelivery(d);
      })
      .catch(function (e) {
        setBusy(form, false);
        if (e.code === 'mobile_unavailable') { settleMobile(false); location.href = EMAIL_URL; return; }
        msg(e.message);
      });
  }

  // WhatsApp can accept a code and then fail to deliver it (number not on WhatsApp,
  // account limits). Meta reports that within seconds; check a few times and offer email.
  var watchId = 0;
  function watchDelivery(d) {
    var id = ++watchId, waits = [3000, 5000, 8000, 12000];
    function check() {
      var wait = waits.shift();
      if (wait == null) return;
      setTimeout(function () {
        if (id !== watchId || !dlg || !dlg.open || q('[data-bsl-step="code"]').hidden) return;
        api('/login/delivery', { phone: d }).then(function (r) {
          if (id !== watchId) return;
          if (r.status === 'failed') {
            msg('WhatsApp couldn’t deliver the code to this number. Use an email code instead, or try again later.');
            var alt = q('.bsl__alt a');
            if (alt) alt.focus();
          } else if (r.status !== 'delivered' && r.status !== 'read') check();
        }, function () {});
      }, wait);
    }
    check();
  }

  function verify() {
    if (busy) return;
    var code = q('#bsl-code').value;
    if (!/^\d{6}$/.test(code)) { msg('Enter the 6-digit code.'); return; }
    var form = q('[data-bsl-step="code"]');
    setBusy(form, true, 'Checking…');
    api('/login/verify', { phone: phone, code: code })
      .then(function (res) {
        setBusy(form, false);
        set(KEY, res.session);
        set(PKEY, JSON.stringify(res.profile || {}));
        paintHeader();
        document.dispatchEvent(new CustomEvent('bagsafe:login', { detail: res.profile }));
        var done = opts.done;
        close();
        if (done) done(res.profile);
        else if (location.pathname === BOOKINGS) location.reload();
        else toast('Signed in' + (res.profile && res.profile.first_name ? ' as ' + res.profile.first_name : '') + '. Your bookings are under My bookings.');
      })
      .catch(function (e) {
        setBusy(form, false);
        msg(e.message);
        var c = q('#bsl-code');
        c.select();
        if (e.code === 'expired') q('[data-bsl-resend]').disabled = false;
      });
  }

  // opts: reason (eyebrow), done (after a mobile sign-in), email (where Google / email goes,
  // e.g. with a return_to), mode 'phone' to skip the chooser when only a mobile session will do.
  function open(o) {
    opts = o || {};
    if (!API) { location.href = opts.email || EMAIL_URL; return; }
    if (!dlg) build();
    q('[data-bsl-reason]').textContent = opts.reason || 'Sign in';
    dlg.querySelectorAll('[data-bsl-shopify]').forEach(function (a) { a.setAttribute('href', opts.email || EMAIL_URL); });
    var p = profile();
    if (p && p.mobile && !q('#bsl-phone').value) q('#bsl-phone').value = p.mobile;
    step(opts.mode === 'phone' ? 'phone' : 'choose');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function close() {
    if (dlg && dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  }

  function signOut(then) {
    var s = session();
    set(KEY, null); set(PKEY, null);
    paintHeader();
    document.dispatchEvent(new CustomEvent('bagsafe:logout'));
    var p = s ? api('/logout', { session: s }).catch(function () {}) : Promise.resolve();
    p.then(function () { if (then) then(); });
  }

  var toastEl;
  function toast(text) {
    loadCss();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bsl-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bs-login-open]');
    if (t && !session() && API) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      var reason = t.getAttribute('data-bs-login-reason') || 'Sign in';
      var email = t.getAttribute('href') || EMAIL_URL;
      // Mobile off: links go on to Shopify's email code; buttons have no href, so send them there.
      if (mobile === false) { if (!t.getAttribute('href')) { e.preventDefault(); location.href = email; } return; }
      e.preventDefault();
      mobileState(function (on) { if (on) open({ reason: reason, email: email, mode: t.getAttribute('data-bs-login-mode') }); else location.href = email; });
      return;
    }
    var out = e.target.closest && e.target.closest('[data-bs-logout]');
    if (out) {
      e.preventDefault();
      signOut(function () { if (location.pathname === BOOKINGS) location.reload(); else toast('Signed out.'); });
    }
  });

  window.BSLogin = { session: session, profile: profile, open: open, close: close, signOut: signOut, api: api, toast: toast,
    mobile: mobileState,
    setProfile: function (p) { if (p) { set(PKEY, JSON.stringify(p)); paintHeader(); } } };

  function init() {
    paintHeader();
    // Ask early so the first click on a login link doesn't wait for it.
    if (API && document.querySelector('[data-bs-login-open], [data-bs-mobile-only]')) mobileState(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
